export default "__VITE_ASSET__Dffvsldp__"